// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// Components
import ClientUpcomingBookings from 'components/Booking/ClientUpcomingBookings';

class ClientBookingModule extends React.Component {

    constructor (props) {
        super(props);
    }

    componentDidMount(){
        this.props.getSBMProviders();
    }

    render(){
        return (
            <ClientUpcomingBookings 
                serviceId={this.props.serviceId}
                serviceSbmId={this.props.serviceSbmId}
                providerData={this.props.providerData}
            />
        );
    }
};

const mapStateToProps = ({ auth, client }) => {
    return {
        userData: client.clientData,
        userId: (auth.authData) ? auth.authData.id : null,
    };
}

export default connect(mapStateToProps, actions)(ClientBookingModule);


// WEBPACK FOOTER //
// ./src/js/components/Booking/ClientBookingModule.jsx